import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import Strings from 'utils/Strings';
import { genderItems } from 'constants/filters/Character';
import { CharacterGender } from 'models/Filters';
import FilterCard from 'components/common/filter-card';
import FilterContainer from 'components/common/filter-container';
import {useAppSelector} from "../../../../../store/hooks";
import {setGenders} from "../../../../../store/marketplace/reducer";

const Gender: React.FunctionComponent = () => {
  const theme = useTheme();
  const { genders } = useAppSelector(state => state.marketplace);
  const dispatch = useDispatch();

  const onSelectHandler = (key: CharacterGender) => {
    const index = genders.findIndex(item => item === key);
    if (index === -1) {
      genders.push(key);
      dispatch(setGenders(genders));
    } else {
      genders.splice(index, 1);
      dispatch(setGenders(genders));
    }
  };

  return (
    <FilterContainer
      className="mt-3"
      title={Strings.gender}
      count={genders.length > 0 ? genders.length : undefined}
      body={
        <div className="d-flex flex-wrap align-items-center justify-content-center mb-3">
          {genderItems.map(({ icon: Icon, type }) => (
            <FilterCard
              key={type}
              // @ts-ignore
              icon={<Icon color={theme.palette.purple} />}
              text={type}
              onClick={() => onSelectHandler(type)}
              active={genders.includes(type)}
              purpleMode
            />
          ))}
        </div>
      }
    />
  );
};
export default Gender;
